const filterOptions = [
  [
    {
      name: 'Closing',
      sort: true,
      rotate: '0',
    },
    {
      name: 'Closing',
      sort: true,
      rotate: '180deg',
    },
    {
      name: 'Hotness',
      sort: true,
      rotate: '0',
    },
    {
      name: 'Hotness',
      sort: true,
      rotate: '180deg',
    },
    {
      name: 'Reward',
      sort: true,
      rotate: '0',
    },
    {
      name: 'Reward',
      sort: true,
      rotate: '180deg',
    },
  ],
  [
    {
      name: 'Both',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Closed',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Active',
      sort: false,
      rotate: '0',
    },
  ],
  [
    {
      name: 'All',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Tabular',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Text',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Image',
      sort: false,
      rotate: '0',
    },
  ],
  [
    {
      name: 'Both',
      sort: false,
      rotate: '0',
    },
    {
      name: 'Yes',
      sort: false,
      rotate: '0',
    },
    {
      name: 'No',
      sort: false,
      rotate: '0',
    },
  ],
];

export default filterOptions;
